import { useMutation } from "@tanstack/react-query";
import {
  recoverWatermark,
  RecoverWatermarkPayload,
  RecoverWatermarkResponse,
} from "../services/watermarkRecoveryApi";

/**
 * Mutation hook for the admin watermark-recovery form. Stateless — no cache to
 * invalidate (recovery is a read-only brute-force lookup, audited server-side).
 */
export const useWatermarkRecovery = () =>
  useMutation<RecoverWatermarkResponse, unknown, RecoverWatermarkPayload>({
    mutationFn: (payload) => recoverWatermark(payload),
  });
